import ContainerMd from "../../components/Layouts/ContainerMd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { updateStudent } from "../../api/endpoints/students/students";
import { updateTutor } from "../../api/endpoints/tutors/tutors";
import UserPersonalInfo from "../../components/personalInfo/UserPersonalInfo";
import { updateLiaison } from "../../api/endpoints/liaisons/liaisons";
import { createBrowserHistory } from "history";
import {
  PERSONAL_INFO_STEP_INDEX,
  STUDENT_STEPS,
  TUTOR_STEPS,
} from "./completeAccountUtils";
import { useAuth, UserType } from "../../context/AuthContext";
import { createCandidate } from "../../api/endpoints/candidate/cadidates";
import { updateSupervisor } from "../../api/endpoints/supervisors/supervisor";

export default function FillAccountInfoPage() {
  const userContext = useAuth();
  const history = createBrowserHistory();
  const location = useLocation();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const isStudent = userContext?.userType === UserType.Student;
  const isTutor = userContext?.userType === UserType.Tutor;
  const isLiaison = userContext?.userType === UserType.Liaison;
  const isSupervisor = userContext?.userType === UserType.Supervisor;

  /* TODO change  */
  const isCandidate = location.pathname.includes("candidate");

  const userUpdateMethod = async (data: any) => {
    if (isStudent) {
      return updateStudent(data);
    } else if (isTutor) {
      return updateTutor(data);
    } else if (isLiaison) {
      return updateLiaison(data);
    } else if (isSupervisor) {
      return updateSupervisor(data);
    } else {
      return createCandidate(data);
    }
  };

  const afterSubmit = async (email?: string) => {
    await userContext?.fetchCurrentUser();
    if (isStudent) {
      navigate(STUDENT_STEPS[PERSONAL_INFO_STEP_INDEX + 1].route);
    } else if (isTutor) {
      navigate(TUTOR_STEPS[PERSONAL_INFO_STEP_INDEX + 1].route);
    } else if (isLiaison || isSupervisor) {
      navigate(`/`);
    } else {
      navigate("/candidate/success-sign", {
        state: { email },
      });
    }
  };
  const prevPage = async () => {
    await userContext?.fetchCurrentUser();
    if (isStudent) {
      navigate(STUDENT_STEPS[PERSONAL_INFO_STEP_INDEX - 1].route);
    } else if (isTutor) {
      navigate(TUTOR_STEPS[PERSONAL_INFO_STEP_INDEX - 1].route);
    } else if (isLiaison || isSupervisor) {
      navigate(`/`);
    }
  };

  let submitButtonText = t("page.steps.save");
  let previousButtonText = "";
  let stepInfo = "";
  if (isStudent) {
    submitButtonText = `${t("page.steps.next")}: ${t(
      STUDENT_STEPS[PERSONAL_INFO_STEP_INDEX + 1].name
    )}`;
    if (PERSONAL_INFO_STEP_INDEX > 0) {
      previousButtonText = `${t("page.steps.previous")}: ${t(
        STUDENT_STEPS[PERSONAL_INFO_STEP_INDEX - 1].name
      )}`;
    }

    stepInfo = `${PERSONAL_INFO_STEP_INDEX + 1} ${t("page.steps.of")} ${
      STUDENT_STEPS.length
    }`;
  } else if (isTutor) {
    submitButtonText = `${t("page.steps.next")}: ${t(
      TUTOR_STEPS[PERSONAL_INFO_STEP_INDEX + 1].name
    )}`;
    if (PERSONAL_INFO_STEP_INDEX > 0) {
      previousButtonText = `${t("page.steps.previous")}: ${t(
        TUTOR_STEPS[PERSONAL_INFO_STEP_INDEX - 1].name
      )}`;
    }

    stepInfo = `${PERSONAL_INFO_STEP_INDEX + 1} ${t("page.steps.of")} ${
      TUTOR_STEPS.length
    }`;
  }
  return (
    <ContainerMd>
      <UserPersonalInfo
        updateUser={userUpdateMethod}
        user={userContext?.currentUser!}
        afterSubmit={afterSubmit}
        prevPage={prevPage}
        isEditable={false}
        submitButtonText={submitButtonText}
        previousButtonText={previousButtonText}
        stepInfo={stepInfo}
        candidateStatus={isCandidate}
      />
    </ContainerMd>
  );
}
